import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  FormControl,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
} from "@mui/material";
import { useState, useCallback } from "react";
import { useGetLessonTermsLookUpQuery } from "../../../api/lessonNoteApi";
import DeleteIcon from '@mui/icons-material/Delete';
import { red } from "@mui/material/colors";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/QualityAssurance";
import { useParams } from "react-router-dom";

const AddActivity = ({ onSuccess }) => {
  const { admToken, user } = useSelector((state) => state.auth);
  const [dateType, setDateType] = useState('single');
  const {calendarId} = useParams()
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    activityDateType: 'single',
    activityDateFrom: '',
    activityDateTo: '',
  });

  const [activities, setActivities] = useState([
    {
      title: "",
      description: ""
    }
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    setFormData(prev => ({
      ...prev,
      activityDateType: value,
      activityDateFrom: '',
      activityDateTo: '',
    }));
  };

  const handleActivityChange = (index, e) => {
    const { name, value } = e.target;
    const updatedActivities = [...activities];
    updatedActivities[index] = {
      ...updatedActivities[index],
      [name]: value
    };
    setActivities(updatedActivities);
  };

  const addActivity = () => {
    setActivities([...activities, { title: "", description: "" }]);
  };

  const removeActivity = (index) => {
    if (activities.length > 1) {
      const updatedActivities = [...activities];
      updatedActivities.splice(index, 1);
      setActivities(updatedActivities);
    }
  };

  const handleSubmit = useCallback(async () => {
    try {
      setLoading(true);
      const payload = {
        calendarId: Number(calendarId),
        name: formData.name,
        activityDateType: dateType,
        activityDateFrom: formData.activityDateFrom,
        activityDateTo: dateType === 'single' ? formData.activityDateFrom : formData.activityDateTo,
        activityItems: activities.map(a => ({ title: a.title, description: a.description }))
      };
      const res = await api.addActivities(admToken, payload);
      if (res.status && res.statusCode === 2) {
        toast.success(res.data.message || "Activity Successfully Added", {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        setFormData({
          name: '',
          activityDateType: 'single',
          activityDateFrom: '',
          activityDateTo: '',
        });
        setActivities([{ title: '', description: '' }]);
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message)
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to add activity");
    } finally {
      setLoading(false);
    }
  }, [admToken, formData, user?.schoolId, activities, dateType, onSuccess]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={dateType}
              onChange={handleDateTypeChange}
            >
              <FormControlLabel
                value="single"
                control={<Radio />}
                label="Single Date"
              />
              <FormControlLabel
                value="range"
                control={<Radio />}
                label="Date Range"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              {dateType === 'single' ? 'Activity Date' : 'Start Date'}
            </InputLabel>
            <TextField
              name="activityDateFrom"
              fullWidth
              size="small"
              type="datetime-local"
              value={formData.activityDateFrom}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>

        {dateType === 'range' && (
          <Grid item xs={12}>
            <Box>
              <InputLabel
                sx={{
                  mb: 1.5,
                  mt: 1,
                  fontSize: "12px",
                  fontWeight: "bolder",
                  color: "#000",
                  fontFamily: "Gilroy-Medium",
                }}
              >
                End Date
              </InputLabel>
              <TextField
                name="activityDateTo"
                fullWidth
                size="small"
                type="datetime-local"
                value={formData.activityDateTo}
                onChange={handleChange}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "1px solid #671E78",
                    },
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Grid>
        )}

        <Grid item xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
                shadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
              }}
            >
              Name of Activity
            </InputLabel>
            <TextField
              name="name"
              fullWidth
              size="small"
              value={formData.name}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
            />
          </Box>
        </Grid>
        {activities.map((activity, index) => (
          <Grid container key={index} ml={1} mt={1}>
            <Grid item xs={12}>
              <Box>
                <InputLabel
                  sx={{
                    mb: 1.5,
                    mt: 1,
                    fontSize: "12px",
                    fontWeight: "bolder",
                    color: "#000",
                    fontFamily: "Gilroy-Medium",
                    shadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {index === 0 ? 'Activity Title' : `Additional Title ${index}`}
                </InputLabel>
                <TextField
                  name="title"
                  fullWidth
                  size="small"
                  value={activity.title}
                  onChange={(e) => handleActivityChange(index, e)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #671E78",
                      },
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box position="relative">
                <InputLabel
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1.5,
                    mt: 1,
                    fontSize: "12px",
                    fontWeight: "bolder",
                    color: "#000",
                    fontFamily: "Gilroy-Medium",
                    shadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {index === 0 ? 'Activity Description' : `Additional Description ${index}`}
                  {activities.length > 1 && (
                    <IconButton
                      onClick={() => removeActivity(index)}
                      sx={{
                        color: red[500],
                        pointerEvents: 'cursor',
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </InputLabel>
                <TextField
                  name="description"
                  fullWidth
                  size="small"
                  value={activity.description}
                  onChange={(e) => handleActivityChange(index, e)}
                  multiline
                  minRows={2}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #671E78",
                      },
                      "& textarea": {
                        minHeight: "80px",
                      },
                      padding: "8px",
                    },
                  }}
                  placeholder="Enter description here"
                />
              </Box>
            </Grid>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Button
            variant="outlined"
            onClick={addActivity}
            sx={{
              textTransform: "initial",
              mb: 2
            }}
          >
            Add More Activities
          </Button>
        </Grid>
      </Grid>

      <Box mt={5}>
        <Button
          variant="contained"
          fullWidth
          sx={{ textTransform: "initial" }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Adding..." : "Add Activity"}
        </Button>
      </Box>
    </Box>
  );
};

export default AddActivity;